<template>
  <q-slide-item
    data-test-id="kitchen-order-item-slide-item"
    class="no-wrap"
    :style="{
      'border-left': `${8 + (4 * indent)}px solid ${orderCardStyles.background}`,
      'color': textColor,
      'background-color': backgroundColor
    }"
    left-color="negative"
    right-color="positive"
    @left="({ reset }) => handleSwipeLeft(reset)"
    @right="({ reset }) => handleSwipeRight(reset)"
    @click="promptOrderActions()"
  >
    <template
      v-if="canSwipeLeft"
      #left
    >
      <q-icon
        name="backspace"
        left
      />
    </template>
    <template
      v-if="canSwipeRight"
      #right
    >
      <q-icon
        name="checkmark"
        right
      />
    </template>
    <q-item
      style="min-height: 32px; padding: 2px 8px;"
    >
      <kitchen-order-item-item
        :index="index"
        :kitchen-display="kitchenDisplay"
        :order="order"
        :order-items="orderItems"
        :tab="tab"
        :show-preparation-counter="showPreparationCounter"
        :show-prep-icon="readyToPrep"
        :relative-prep-time-label="relativePrepTime"
      />
    </q-item>
    <q-separator />
  </q-slide-item>
</template>

<script>
import { STAGES } from 'src/models/kitchen-display/KitchenDisplayType'
import KitchenOrderItemItem from 'src/modules/kds/components/kitchen-card/KitchenOrderItemItem'
import KitchenCardMixin from 'src/modules/kds/components/kitchen-card/mixins/KitchenCardMixin'

export default {
  name: 'KitchenOrderItemSlideItem',
  components: {
    KitchenOrderItemItem
  },
  configuration: ['currentSite'],
  mixins: [KitchenCardMixin],
  props: {
    indent: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    // All orderItems are the same when grouped in an expansion / slide item, so we can just use the first one for all operations
    orderItem () {
      return _.first(this.orderItems)
    },
    backgroundColor () {
      if (this.selected) {
        return this.$lightenColor(this.currentSite.accentColor, this.$isColorDark(this.currentSite.accentColor) ? 15 : -15)
      }

      if (this.tab === STAGES.OPEN && this.orderItem.isReadyForDelivery) {
        return this.$lightenColor(this.currentSite.positiveColor, 85)
      }

      return '#FFFFFF'
    },
    textColor () {
      return this.$isColorDark(this.backgroundColor) ? 'white' : 'black'
    }
  }
}
</script>
